import { He6UltraDeviceList } from '@/define/device_vendor'
import { DeviceProtocolBase } from './device_model'
import { VirtualFE87V2_MuYan } from '@hid/define/define'

export class DeviceWeb implements DeviceProtocolBase {
  // private device: HIDDevice | null = null
  private fnOnReceive: ((data: number[]) => void) | null = null
  private reportID = 0

  onReceive(fn: (data: number[]) => void) {
    this.fnOnReceive = fn
  }

  constructor(private device: HIDDevice) {}

  send(data: number[]): void {
    if (!this.device) return
    // console.log("send", this.reportID, new Uint8Array(data))
    this.device
      .sendReport(this.reportID, new Uint8Array(data))
      .then((_res) => {})
      .catch((e) => {
        throw new Error(e)
        console.log('debug1:', e)
      })
  }

  async sendFeature(data: number[]) {
    if (!this.device) return
    this.device
      .sendFeatureReport(this.reportID, new Uint8Array(data))
      .then((_res) => {})
      .catch((e) => {
        throw new Error(e)
        console.log('debug1:', e)
      })

    setTimeout(() => {
      this.device.receiveFeatureReport(this.reportID).then((e) => {
        if (!this.fnOnReceive) return
        const bytes = Array.from(new Uint8Array(e.buffer))
        // printHex(bytes, "r")
        this.fnOnReceive(bytes)
      })
    }, 1)
  }

  async connect(): Promise<boolean> {
    if (!this.device) return false
    if (this.device.opened == false) {
      await this.device.open().catch((error) => {
        console.error('open error:', error)
        return false
      })
    }
    const device = (this.device.vendorId << 16) | this.device.productId
    if (He6UltraDeviceList.includes(device)) {
      this.reportID = 0x08
    }
    if (VirtualFE87V2_MuYan == device) {
      this.reportID = 0x06
    }
    console.log('connect:', this.device)
    this.device.oninputreport = (e) => {
      if (!this.fnOnReceive) return
      const bytes = Array.from(new Uint8Array(e.data.buffer))
      // printHex(bytes, "r")
      this.fnOnReceive(bytes)
    }
    return true
  }

  initDevice = async () => {}
}
